import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { InsideBlock, insidePages } from '../data/content';
import { Eyebrow, SectionLead, SectionTitle } from './ui/Section';
export function InsidePreview() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-172" data-mp="2mb4j4z6ie3t2">
      <div className="mx-auto max-w-6xl" data-id="element-173" data-mp="2hb03fbdfdd3w">
        <Eyebrow data-id="element-174" data-mp="2hc1n248ib7x8">🔍 A Look Inside</Eyebrow>
        <SectionTitle data-id="element-175" data-mp="2hdcss9liipqz">What will you actually find inside?</SectionTitle>
        <SectionLead data-id="element-176" data-mp="3ey7h9q79wcis">
          Not pages of generic decluttering theory. You get questions, decision paths, trackers,
          category rules, and practical tools you can use while standing in front of the actual
          clutter.
        </SectionLead>

        <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-177" data-mp="30ae0412jh1y3">
          {insidePages.map(page => <article key={page.title} className="flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-178" data-mp="1k46d2z1k4h6">
              <h3 className="bg-blue-950 px-5 py-3 text-sm font-black uppercase tracking-wide text-white md:text-base" data-id="element-179" data-mp="3lps09zz7f7m2">
                {page.emoji} {page.title}
              </h3>
              <div className="flex flex-1 flex-col p-5" data-id="element-180" data-mp="3qqfqwkjitmfr">
                {page.item && <p className="mb-3 text-sm font-black text-blue-950" data-id="element-181" data-mp="3bxvyoexwszd3">
                    <span className="text-xs uppercase tracking-wide text-slate-500" data-id="element-182" data-mp="3gx8lx0sp08g7">Item: </span>
                    {page.item}
                  </p>}
                <div className="space-y-3" data-id="element-183" data-mp="370vru1t8jskx">
                  {page.blocks.map((block, index) => <Block key={index} block={block} data-id="element-184" data-mp="2t1nnkui7tu9v" data-mpi={index} />)}
                </div>

                {(page.resultLabel || page.outcomes || page.footnote) && <div className="mt-auto pt-5" data-id="element-185" data-mp="r9r4mztpxi52">
                    {page.resultLabel && <p className="flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wide text-slate-500" data-id="element-186" data-mp="w8km13c4ltai">
                        <ArrowRightIcon className="h-3.5 w-3.5 text-yellow-700" aria-hidden="true" data-id="element-187" data-mp="usgh9qlkcf8i" />
                        {page.resultLabel}
                      </p>}
                    {page.resultNote && <p className="mt-1.5 text-sm font-black text-blue-950" data-id="element-188" data-mp="kthhyymotvy6">{page.resultNote}</p>}
                    {page.outcomes && <div className="mt-2 flex flex-wrap gap-1.5" data-id="element-189" data-mp="1di6e0j8vzb32">
                        {page.outcomes.map(outcome => <span key={outcome} className="rounded-md bg-amber-100 px-2 py-1 text-[11px] font-black text-blue-950" data-id="element-190" data-mp="18jbrb67st2do">
                            {outcome}
                          </span>)}
                      </div>}
                    {page.footnote && <p className="text-sm font-black text-blue-950" data-id="element-191" data-mp="1rg4kz3kvo58j">{page.footnote}</p>}
                  </div>}
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}
function Block({
  block
}: {
  block: InsideBlock;
}) {
  if (block.type === 'qa') {
    return <div className="flex items-start justify-between gap-3 border-b border-slate-100 pb-2 text-sm" data-id="element-192" data-mp="2dptkmq0nq22m">
        <span className="font-semibold text-slate-700" data-id="element-193" data-mp="2ipfuqql6v277">{block.q}</span>
        {block.a && <span className="shrink-0 text-right font-black text-blue-950" data-id="element-194" data-mp="2mqrq7cqquhnb">{block.a}</span>}
      </div>;
  }
  if (block.type === 'field') {
    return <div className="text-sm" data-id="element-195" data-mp="2risw8gxbjc4w">
        <p className="font-bold text-slate-700" data-id="element-196" data-mp="2rjks7sutvbvp">{block.label}:</p>
        <div className="mt-2 h-5 border-b-2 border-dashed border-slate-300" data-id="element-197" data-mp="2wf9nvl3q88mq" />
      </div>;
  }
  return <div className="text-sm" data-id="element-198" data-mp="31h8seyb7dbl9">
      {block.label && <p className="font-bold text-slate-700" data-id="element-199" data-mp="36eio2vp6qjhj">{block.label}</p>}
      <ul className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1.5" data-id="element-200" data-mp="36f0kbsbukxpg">
        {block.options.map(option => <li key={option} className="flex items-center gap-2 font-semibold text-slate-700" data-id="element-201" data-mp="6yoldfhyciy1">
            <span className="h-4 w-4 shrink-0 rounded border-2 border-slate-300" aria-hidden="true" data-id="element-202" data-mp="1zkeivii2xav" />
            {option}
          </li>)}
      </ul>
    </div>;
}